module.exports = __webpack_public_path__ + "static/media/sculpture-2.1e912363.jpg";